<template>
  <div>
    <el-form :model="form">
      <el-form-item
        label="管理员账号"
        prop="account"
        :label-width="formLabelWidth"
      >
        <el-input
          placeholder="请输入管理员账号"
          v-model="form.account"
          autocomplete="off"
          class="input"
        />
      </el-form-item>
      <el-form-item
        label="密码"
        prop="password"
        :label-width="formLabelWidth"
      >
        <el-input
          placeholder="请输入管理员账号密码"
          v-model="form.password"
          autocomplete="off"
          class="input"
          v-if="type==='add'"
        />
        <el-input
          placeholder="如果不修改请传空"
          v-model="form.password"
          autocomplete="off"
          class="input"
          v-if="type==='edit'"
        />
      </el-form-item>
      <el-form-item
        label="姓名"
        prop="name"
        :label-width="formLabelWidth"
      >
        <el-input
          placeholder="请输入管理员姓名"
          v-model="form.name"
          autocomplete="off"
          class="input"
        />
      </el-form-item>
      <el-form-item
        label="联系方式"
        prop="user_mobile"
        :label-width="formLabelWidth"
      >
        <el-input
          placeholder="请输入管理员联系方式"
          v-model="form.mobile"
          autocomplete="off"
          class="input"
        />
      </el-form-item>
      <el-form-item
        label="管理员身份"
        prop="group_id"
        :label-width="formLabelWidth"
      >
        <el-select
          v-model="form.group_id"
          class="input"
        >
          <el-option
            v-for="item in identTable"
            :key="item.id"
            :label="item.title"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <!-- <el-form-item
        label="关联酒店"
        prop="name"
        :label-width="formLabelWidth"
      >
        <div
          v-if="selectHotel.length"
          class="select-hotel"
        >
          <div
            v-for="item of selectHotel"
            :key="item.uuid"
            class="item"
          >{{item.hotel_name}}</div>
        </div>
        <div
          v-else
          class="select-hotel"
        >暂未关联酒店</div>
        <el-button
          type="primary"
          class="selectBth"
          @click="onSelectHotelClick"
        >关联酒店</el-button>
      </el-form-item> -->
     <!-- <el-form-item :label-width="formLabelWidth">
        <el-checkbox v-model="checked">是否接受消息通知</el-checkbox>
      </el-form-item> -->
      <el-button
        type="primary"
        class="saveBth"
        @click="onSaveClick"
      >保存</el-button>
    </el-form>
    <select-hotel-dialog
      title="选择酒店"
      :dialogVisible="hotelDialogVisible"
      :type="type"
      :hotel_uuid="hotel_uuid"
      :hotelList="hotelList"
      @cancel="hotelDialogVisible = false"
      @confirm="hotelDialogConfirm"
      @close="hotelDialogVisible = false"
    ></select-hotel-dialog>
  </div>
</template>

<script>
import {
  identityOf,
  getAuthListDetail,
  addAdminUser,
  editAuthUser
} from "@/api/auth";
import SelectHotelDialog from "./components/SelectHotelDialog";
import { mapState, mapActions } from "vuex";

export default {
  name: "handleadmin",
  data() {
    return {
      formLabelWidth: "120px",
      form: {
        name: "",
        mobile: "",
        account: "",
        password: "",
        group_id: ""
      },
      checked: false,
      type: "add",
      identTable: [], //身份列表
      hotelDialogVisible: false,
      selectHotel: [],
      hotel_uuid: [],
      hotelList: []
    };
  },
  components: {
    SelectHotelDialog
  },
  async mounted() {
    // this.getCommonInfo();
    // await this.getIdentityList();
    // const { uuid } = this.$route.query;
    // if (uuid) {
    //   this.type = "edit";
    //   this._getAuthListDetail(uuid);
    // } else {
    //   this.type = "add";
    //   this.form = {
    //     name: "",
    //     mobile: "",
    //     account: "",
    //     password: "",
    //     group_id: ""
    //   };
    //   this.checked = false;
    //   this.selectHotel = [];
    //   this.hotel_uuid = [];
    // }
  },
  computed: {
    ...mapState(["loginData"])
  },
  methods: {
    ...mapActions(["getCommonInfo"]),
    async _getAuthListDetail(uuid) {
      const { data, status } = await getAuthListDetail(uuid);
      if (status === 200) {
        data.password = "";
        data.group_id = data.group.id;
        this.form = data;
        if (data.is_order_notice === "1") {
          this.checked = true;
        } else {
          this.checked = false;
        }
        console.log(data, "detail");
        if (data.hotel_uuid && data.hotel_uuid.length) {
          this.hotel_uuid = data.hotel_uuid;
          this.getSelectHotel(data.hotel_uuid);
        }
      }
    },
    async getIdentityList() {
      let postData = {
        page_index: 1,
        page_size: 99
      };
      const { data, status } = await identityOf(postData);
      if (status !== 200) return;
      // if (data.char.length) {
      // 	//身份id是数字类型的 管理员列表对应group_id 是字符串类型。 这一步是把id变为字符串类型已匹配group_id
      // 	data.char.forEach(item => {
      // 		item.id += '';
      // 	})
      // }
      this.identTable = data.char;
    },
    hotelDialogConfirm(hotels) {
      this.hotel_uuid = hotels.map(hotel => hotel.uuid);
      this.selectHotel = hotels;
      this.hotelDialogVisible = false;
    },
    onSelectHotelClick() {
      this.hotelDialogVisible = true;
    },
    getSelectHotel(uuidlist) {
      //编辑时
      let hotelData = [];
      this.hotelList.forEach(item => {
        if (uuidlist.includes(item.uuid)) {
          hotelData.push(item);
        }
      });
      this.selectHotel = hotelData;
    },
    async onSaveClick() {
      const { name, mobile, account, group_id, password } = this.form;
      if (!account) {
        this.$message("请输入管理员账号");
        return;
      }
      if (this.type === "add" && !password) {
        this.$message("请输入密码");
        return;
      }
      if (!name) {
        this.$message("请输入管理员姓名");
        return;
      }
      if (!mobile) {
        this.$message("请输入联系方式");
        return;
      }
      if (!group_id) {
        this.$message("请选择管理员身份");
        return;
      }
      // if (this.selectHotel.length) {
      //   let hotel_uuid = [];
      //   this.selectHotel.forEach(item => {
      //     hotel_uuid.push(item.uuid);
      //   });
      //   this.form.hotel_uuid = hotel_uuid;
      // } else {
      //   this.$message("请选择关联酒店");
      //   return;
      // }
      this.form.is_order_notice = this.checked ? "1" : "2";
      let resStatus;
      if (this.type === "add") {
        ({ status: resStatus } = await addAdminUser(this.form));
      } else {
        ({ status: resStatus } = await editAuthUser(this.form));
      }
      if (resStatus === 200) {
        this.$router.go(-1);
      }
    },
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/styles/variables.less";
@import "~@/assets/styles/mixins.less";

.input {
  width: 300px;
}
.select-hotel {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  padding: 20px;
  box-shadow: 0px 2px 8px 0px rgba(26, 66, 70, 0.1);
  .item {
    margin-right: 20px;
  }
}
.selectBth {
  display: block;
  margin-top: 20px;
}
.saveBth {
  display: block;
  margin: 50px auto 0;
}
</style>
